import { useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';

export const useQueryParams = (queries: Record<string, string | string[] | number | undefined | null>) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const queryDependency = JSON.stringify(queries);

  useEffect(() => {
    Object.keys(queries).forEach((queryKey) => {
      if (queries[queryKey]) {
        searchParams.set(queryKey, `${queries[queryKey]}`);
      } else {
        searchParams.delete(queryKey);
      }
    });

    setSearchParams(searchParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryDependency]);
};
